module.exports = __webpack_public_path__ + "static/img/Master.c525bd90.png";